// extracted by mini-css-extract-plugin
export default {"reviewsWrapper":"Reviews_reviewsWrapper__AT7iD","reviews":"Reviews_reviews__P0vO7","singleReview":"Reviews_singleReview__2dRIA"};